import { format } from 'date-fns';

export enum DateFormat {
  yyyyMMdd = 'yyyy-MM-dd',
  doMMMMyyyy = 'do MMMM yyyy',
  MMyyyy = 'MM/yyyy',
  ddMMyyyy = 'dd/MM/yyyy',
}

/**
 * @description
 * converts utc date type (ex: 2022-03-09T05:43:43.579Z) to required date format
 * default format: yyyy-MM-dd
 */

export const utcDateFormatter = (
  dateString: string,
  formatString: DateFormat = DateFormat.yyyyMMdd
) => format(new Date(JSON.parse(dateString)), formatString);

/**
 * @description
 * converts to required date format
 * default format: yyyy-MM-dd
 */

export const dateFormatter = (
  date: Date | number | string,
  formatString: DateFormat = DateFormat.yyyyMMdd
) => (typeof date === 'string' ? format(new Date(date), formatString) : format(date, formatString));
